import { context, Configurable } from "./configurable.js";
import { mergeRight } from "./merge.js";
const env = context.prop("env");
const envName = env.chain((env2) => {
  switch (env2) {
    case "local":
      return "local";
    case "dev":
      return "development";
    case "stg":
      return "staging";
    case "prod":
      return "production";
  }
});
function isEnvironment(x) {
  return ["local", "dev", "stg", "prod"].includes(x);
}
function isDevLikeEnv(env2) {
  return ["local", "dev"].includes(env2);
}
const locale = context.chain((context2) => {
  if (context2.locale === void 0) {
    throw new Error(`Locale is not available in the context.`);
  }
  return context2.locale;
});
const brand = context.chain((context2) => {
  if (context2.brand === void 0) {
    throw new Error("Brand is not available in the context.");
  }
  return context2.brand;
});
const siteContext = Configurable.props({
  env,
  locale,
  brand
});
function environment(cases) {
  return envName.chain((name) => {
    return Configurable.props(cases).chain((values) => {
      if ("default" in values) {
        const value = values[name];
        return name in values ? value : values.default;
      } else {
        return values[name];
      }
    });
  });
}
function forBrand(cases) {
  return brand.chain((brand2) => {
    const value = cases[brand2];
    if (value === void 0) {
      throw new Error(`Can't load configurable for brand ${brand2}`);
    }
    return value;
  });
}
function forLocale(cases) {
  return locale.chain((locale2) => {
    const [lang, country] = locale2.split("_");
    const langConfig = Configurable.of(cases[lang]);
    const countryConfig = Configurable.of(cases[country]);
    const localeConfig = Configurable.of(cases[locale2]);
    return langConfig.chain((langVal) => countryConfig.chain((countryVal) => mergeRight(langVal, countryVal))).chain((countryVal) => localeConfig.chain((localeVal) => mergeRight(countryVal, localeVal)));
  });
}
function development(value) {
  return environment({
    development: value,
    default: void 0
  });
}
function promotedUpto(promotedTo, value) {
  const envs = ["local", "dev", "stg", "prod"];
  return env.chain((env2) => {
    const envIndex = envs.indexOf(env2);
    const promotedToEnvIndex = envs.indexOf(promotedTo);
    const active = 0 <= envIndex && envIndex <= promotedToEnvIndex;
    return active ? value : void 0;
  });
}
function only(selectBrand, value, fallback) {
  return brand.chain((brand2) => {
    return brand2 === selectBrand ? value : fallback;
  });
}
function cfg(strs, ...placeholders) {
  return new Configurable((context2) => {
    const output = [strs[0]];
    for (let i = 0; i < placeholders.length; i++) {
      const value = Configurable.of(placeholders[i]).evaluateWithContext(context2);
      output.push(value, strs[i + 1]);
    }
    return output.join("");
  });
}
export {
  brand,
  cfg,
  development,
  env,
  envName,
  environment,
  forBrand,
  forLocale,
  isDevLikeEnv,
  isEnvironment,
  locale,
  only,
  promotedUpto,
  siteContext
};
//# sourceMappingURL=base.js.map
